

// Variant selection helpers
var optionSyncing = false;
var pageJustLoaded = true;
function getActiveRadio() {
  return $('.single-product__radio-input:checked').first();
}

function getActiveFormClass($radio) {
  if (!$radio || !$radio.length) return 'main-product-form';
  return $radio.data('form') || 'main-product-form';
}

function getProductFormClass($wrapper) {
  if (!$wrapper || !$wrapper.length) return 'main-product-form';
  var classes = ($wrapper.attr('class') || '').split(/\s+/);
  var matchedClass = null;
  var fallbackUpsell = null;

  $.each(classes, function(_, cls) {
    if (!cls) return;
    if (cls.indexOf('upsell-product-form-') === 0) {
      matchedClass = cls;
      return false;
    }
    if (cls === 'main-product-form') {
      matchedClass = cls;
      return false;
    }
    if (cls === 'upsell-product-form') {
      fallbackUpsell = cls;
    }
  });

  return matchedClass || fallbackUpsell || 'main-product-form';
}

function buildFrequencyDropdown($formWrapper) {
  var $dataEl = $formWrapper.find('.selling-plan-data');
  if (!$dataEl.length) return;

  var plansByVariant;
  try { plansByVariant = JSON.parse($dataEl.text()); } catch(e) { return; }

  var $variantSelect = $formWrapper.find('select[name="id"]');
  var variantId = $variantSelect.length
    ? $variantSelect.val()
    : $formWrapper.find('input[name="id"]').val();

  var plans = (variantId && plansByVariant[variantId]) ? plansByVariant[variantId] : [];
  var $wrap = $formWrapper.find('.frequency-select-wrap').not('.bundle-frequency-wrap');
  var $dropdown = $formWrapper.find('.freq-dropdown').not('.bundle-freq-dropdown');

  if (!$wrap.length || !$dropdown.length) return;

  if (plans.length <= 1) {
    $wrap.hide();
    if (plans.length === 1) {
      $formWrapper.find('.selling__plan-set-value').val(plans[0].id);
    }
    return;
  }

  var prevId = parseInt($dropdown.attr('data-selected-id'), 10) || null;
  var stillAvailable = prevId && plans.some(function(p) { return p.id === prevId; });
  var selected = stillAvailable ? plans.find(function(p) { return p.id === prevId; }) : plans[0];

  var $list = $dropdown.find('.freq-dropdown__list');
  $list.empty();
  $.each(plans, function(i, plan) {
    $list.append(
      $('<li>')
        .addClass('freq-dropdown__option')
        .attr({ role: 'option', 'aria-selected': plan.id === selected.id ? 'true' : 'false', 'data-value': plan.id, tabindex: '-1' })
        .text(plan.name)
    );
  });

  $dropdown.find('.freq-dropdown__selected-text').text(selected.name);
  $dropdown.attr('data-selected-id', selected.id);
  $formWrapper.find('.selling__plan-set-value').val(selected.id);

  var $subscribeInput = $formWrapper.find('.single-product__radio-input').filter(function() {
    var id = $(this).attr('id');
    return id === 'subscribe' || id === 'upsell-subscribe';
  });
  if (!$subscribeInput.length || $subscribeInput.is(':checked')) {
    $wrap.show();
  } else {
    $wrap.hide();
  }
}

function updateVariantImage(variant_featured_img, variant_srcset, formClass) {
  if (!variant_featured_img || pageJustLoaded) {
    return;
  }

  // console.log('updateVariantImage called with:', variant_featured_img, 'formClass:', formClass);
  var targetFormClass = (typeof formClass === 'string' && formClass.length) ? formClass : getActiveFormClass(getActiveRadio());
  // console.log('Target form class:', targetFormClass);
  if($('.product-slider-wrapper').length > 0){
    var $sliderWrapper = $('.product-slider-wrapper.' + targetFormClass);
    // console.log('Looking for slider with class:', targetFormClass, 'Found:', $sliderWrapper.length);

    if (!$sliderWrapper.length) {
      // console.log('Slider not found, trying main-product-form');
      $sliderWrapper = $('.product-slider-wrapper.main-product-form');
      // console.log('Main product form slider found:', $sliderWrapper.length);
    }

    var $imagesContainer = $sliderWrapper.find('.product__images');
    var slickInitialized = $imagesContainer.hasClass('slick-initialized');
    var foundInSlider = false;
    // console.log('Images container found:', $imagesContainer.length, 'Slick initialized:', slickInitialized);
    // console.log('Total slides found:', $sliderWrapper.find('.featured-product__img').length);

    // Normalize image URL by extracting base URL and image ID
    function normalizeImageUrl(url) {
      if (!url) return '';
      // Remove query parameters and hash
      var baseUrl = url.split('?')[0].split('#')[0];
      // Extract image ID from URL (format: /files/1/0001/1234/products/image.jpg)
      var match = baseUrl.match(/\/(\d+)\/(\d+)\/(\d+)\/products\/([^\/]+)/);
      if (match) {
        return match[1] + '/' + match[2] + '/' + match[3] + '/' + match[4];
      }
      // Fallback to base URL without domain
      return baseUrl.split('/').slice(-3).join('/');
    }
    
    // Also check if URLs match by filename
    function getImageFilename(url) {
      if (!url) return '';
      var match = url.match(/\/([^\/\?]+\.(jpg|jpeg|png|gif|webp))/i);
      return match ? match[1].toLowerCase() : '';
    }
    
    var normalizedVariantImg = normalizeImageUrl(variant_featured_img);
    var variantFilename = getImageFilename(variant_featured_img);

    // Find slides - Slick wraps them in .slick-slide, but we need to check the original .featured-product__img inside
    var $allSlides = slickInitialized ? 
      $sliderWrapper.find('.slick-slide .featured-product__img') : 
      $sliderWrapper.find('.featured-product__img');
    
    $allSlides.each(function (slideIndex) {
      var $slide = $(this);
      var $img = $slide.find("img");
      var imgSrc = $img.attr("src") || $img.attr("data-src") || $img.data("src");
      var imgSrcset = $img.attr("srcset") || $img.attr("data-srcset") || '';
      
      // Check all URLs in srcset
      var allUrls = [imgSrc];
      if (imgSrcset) {
        var srcsetUrls = imgSrcset.split(',').map(function(item) {
          return item.trim().split(' ')[0];
        });
        allUrls = allUrls.concat(srcsetUrls);
      }

      // Check if any URL matches
      for (var i = 0; i < allUrls.length; i++) {
        var testUrl = allUrls[i];
        if (!testUrl) continue;
        
        var normalizedImgSrc = normalizeImageUrl(testUrl);
        var imgFilename = getImageFilename(testUrl);
        
        // Match by normalized URL or filename
        if ((normalizedVariantImg && normalizedImgSrc && normalizedVariantImg === normalizedImgSrc) ||
            (variantFilename && imgFilename && variantFilename === imgFilename)) {
          // console.log('Image match found! Normalized match:', normalizedVariantImg === normalizedImgSrc, 'Filename match:', variantFilename === imgFilename);
          
          // Try multiple methods to get the slide index
          var index = null;
          
          if (slickInitialized) {
            // When Slick is initialized, find the parent .slick-slide element
            var $slickSlide = $slide.closest('.slick-slide');
            if ($slickSlide.length) {
              // Get the data-slick-index from the Slick slide wrapper
              index = $slickSlide.attr("data-slick-index");
              // If not found, get index from all slick slides
              if ((index === undefined || index === null || index === '')) {
                var $slickTrack = $slickSlide.closest('.slick-track');
                if ($slickTrack.length) {
                  var $slickSlides = $slickTrack.find('.slick-slide');
                  index = $slickSlides.index($slickSlide);
                }
              }
            }
          }
          
          // Fallback to forEach index if still not found
          if ((index === undefined || index === null || index === '') && index !== 0) {
            index = slideIndex;
          }
          
          // console.log('Slide index:', index, 'Slick initialized:', slickInitialized, 'Slide element:', $slide[0]);
          
          if (slickInitialized && (index !== undefined && index !== null && index !== '')) {
            // console.log('Navigating to slide:', Number(index));
            // Use setTimeout to ensure Slick is ready and force a refresh
            setTimeout(function() {
              try {
                $imagesContainer.slick('slickGoTo', Number(index), false);
                // Force Slick to refresh after navigation
                $imagesContainer.slick('setPosition');
              } catch(e) {
                // console.error('Error navigating slider:', e);
                // Fallback: try to find the slide by data attribute and click it
                var $targetSlide = $sliderWrapper.find('.featured-product__img[data-slick-index="' + index + '"]');
                if ($targetSlide.length) {
                  $targetSlide.trigger('click');
                }
              }
            }, 100);
          } else {
            // Update the image source
            if ($img.length) {
              $img.attr("src", variant_featured_img);
              // Update srcset with provided variant_srcset or generate one
              if (variant_srcset) {
                $img.attr("srcset", variant_srcset);
              } else if ($img.attr("srcset")) {
                var newSrcset = variant_featured_img.replace(/\?.*$/, '') + '?width=180 180w, ' +
                               variant_featured_img.replace(/\?.*$/, '') + '?width=360 360w, ' +
                               variant_featured_img.replace(/\?.*$/, '') + '?width=540 540w, ' +
                               variant_featured_img.replace(/\?.*$/, '') + '?width=720 720w';
                $img.attr("srcset", newSrcset);
              }
            }
          }
          foundInSlider = true;
          return false;
        }
      }
    });

    // If image not found in slider, update the current/active slide
    if (!foundInSlider) {
      // console.log('Image not found in slider, updating current slide');
      if (slickInitialized) {
        var $activeSlide = $sliderWrapper.find('.featured-product__img.slick-current.slick-active');
        if ($activeSlide.length) {
          var $activeImg = $activeSlide.find('img').first();
          if ($activeImg.length) {
            $activeImg.attr("src", variant_featured_img);
            // Update srcset with provided variant_srcset or generate one
            if (variant_srcset) {
              $activeImg.attr("srcset", variant_srcset);
            } else if ($activeImg.attr("srcset")) {
              var newSrcset = variant_featured_img.replace(/\?.*$/, '') + '?width=180 180w, ' +
                             variant_featured_img.replace(/\?.*$/, '') + '?width=360 360w, ' +
                             variant_featured_img.replace(/\?.*$/, '') + '?width=540 540w, ' +
                             variant_featured_img.replace(/\?.*$/, '') + '?width=720 720w';
              $activeImg.attr("srcset", newSrcset);
            }
          }
        }
      } else {
        var $firstImg = $sliderWrapper.find('.featured-product__img').first().find('img');
        if ($firstImg.length) {
          $firstImg.attr("src", variant_featured_img);
          // Update srcset with provided variant_srcset or generate one
          if (variant_srcset) {
            $firstImg.attr("srcset", variant_srcset);
          } else if ($firstImg.attr("srcset")) {
            var newSrcset = variant_featured_img.replace(/\?.*$/, '') + '?width=180 180w, ' +
                           variant_featured_img.replace(/\?.*$/, '') + '?width=360 360w, ' +
                           variant_featured_img.replace(/\?.*$/, '') + '?width=540 540w, ' +
                           variant_featured_img.replace(/\?.*$/, '') + '?width=720 720w';
            $firstImg.attr("srcset", newSrcset);
          }
        }
      }
    }
  } else {
    // Only update the image for the active form
    var targetFormClass = (typeof formClass === 'string' && formClass.length) ? formClass : getActiveFormClass(getActiveRadio());
    var $formWrapper = $('.product-form-wrapper.' + targetFormClass);
    if (!$formWrapper.length > 0) {
      $formWrapper = $('.product-form-wrapper.main-product-form');
    }
    if($formWrapper.is(':visible')) {
      $(".featured__main-img").attr("src", variant_featured_img);
    }

  }
}

function updateVariantSelection(targetFormClass) {
  var eventContext = targetFormClass && typeof targetFormClass.preventDefault === 'function' ? targetFormClass : null;
  var $eventFormWrapper = eventContext ? $(eventContext.currentTarget).closest('.product-form-wrapper') : null;
  var inferredFormClass = $eventFormWrapper && $eventFormWrapper.length ? getProductFormClass($eventFormWrapper) : null;
  var $activeRadio = getActiveRadio();
  var formClass = null;

  var shouldSyncOthers = !optionSyncing;

  if (!eventContext && typeof targetFormClass === 'string' && targetFormClass.length) {
    formClass = targetFormClass;
  } else if (inferredFormClass) {
    formClass = inferredFormClass;
  } else {
    formClass = getActiveFormClass($activeRadio);
  }

  var productType = ($activeRadio && $activeRadio.length) ? $activeRadio.data('product-type') : 'regular-select';
  var $formWrapper = ($eventFormWrapper && $eventFormWrapper.length) ? $eventFormWrapper : $('.product-form-wrapper.' + formClass);

  if (!$formWrapper.length) {
    $formWrapper = $('.product-form-wrapper.main-product-form');
  }

  var normalizedFormClass = getProductFormClass($formWrapper);

  // Get all option select elements within the active form
  var $optionSelects = $formWrapper.find('.featured-product__select-wrap select').not('.bundle-option-select');
  var $variantSelects = $formWrapper.find('select[name="id"]');

  if ($optionSelects.length === 0 || $variantSelects.length === 0) {
    buildFrequencyDropdown($formWrapper);
    updateCartBtnPrice($formWrapper);
    return;
  }
  
  // Collect selected option values
  var selectedOptions = {};
  $optionSelects.each(function() {
    var optionName = $(this).attr('name'); // e.g., 'options1', 'options2', etc.
    var optionNumber = optionName.replace('options', ''); // Extract number
    var optionKey = "option" + optionNumber; // Convert to 'option1', 'option2', etc.
    selectedOptions[optionKey] = $(this).val();
  });
  
  // Update each variant select dropdown within the active form
  $variantSelects.each(function() {
    var $variantSelect = $(this);
    var $options = $variantSelect.find('option');
    var matchingOption = null;
    
    // Find the option that matches all selected option values
    $options.each(function() {
      var $option = $(this);
      var isMatch = true;

      // Check if this option matches all selected option values
      $.each(selectedOptions, function(optionKey, optionVal) {
        var optionAttrVal = $option.attr(optionKey);
        if (optionAttrVal && optionAttrVal !== optionVal) {
          isMatch = false;
        }
      });

      if (isMatch && Object.keys(selectedOptions).length > 0) {
        matchingOption = $option;
      }
    });
    
    // Select the matching option
    if (matchingOption) {

      $variantSelect.val(matchingOption.val());
      // Trigger change event to update any dependent functionality
      $variantSelect.trigger('change');
      
      var variant_image = matchingOption.attr("data-variant-img");
      var variant_srcset = matchingOption.attr("data-variant-srcset");
      if (variant_image) {
        updateVariantImage(variant_image, variant_srcset, normalizedFormClass);
      }
    }
  });

  if (shouldSyncOthers) {
    optionSyncing = true;
    syncOtherFormOptions(selectedOptions, normalizedFormClass);
    optionSyncing = false;
  }

  buildFrequencyDropdown($formWrapper);
  updateOptionPrices($formWrapper);
  updateCartBtnPrice($formWrapper);
}

function updateCartBtnPrice($formWrapper) {
  if ($formWrapper.hasClass('product-form-wrapper--mv')) {
    updateMvButtonPrice($formWrapper);
    return;
  }
  var $btn = $formWrapper.find('.add__cart-btn a');
  var $compareEl = $btn.find('.cart-btn__compare');
  var $priceEl = $btn.find('.cart-btn__price');
  var $priceWrap = $btn.find('.cart-btn__price-wrap');

  if (!$priceEl.length) return;

  var variantId, variantPrice;
  var $variantSelect = $formWrapper.find('select[name="id"]');
  if ($variantSelect.length) {
    var $opt = $variantSelect.find('option:selected');
    variantId = $opt.val();
    variantPrice = $opt.attr('data-variant-price');
  } else {
    var $hidden = $formWrapper.find('input[name="id"].hidden__input-value');
    variantId = $hidden.val();
    variantPrice = $hidden.attr('data-variant-price');
  }
  if (!variantId || !variantPrice) return;

  var $subRadio = $formWrapper.find('.single-product__radio-input').filter(function() {
    var id = $(this).attr('id');
    return id === 'subscribe' || id === 'upsell-subscribe';
  });
  var isSubscription = $subRadio.is(':checked');
  var selectedPlanId = $formWrapper.find('.selling__plan-set-value').val();

  var subPrice = null;
  if (isSubscription) {
    var $planDataEl = $formWrapper.find('.selling-plan-data');
    if ($planDataEl.length) {
      try {
        var planData = JSON.parse($planDataEl.text());
        var plans = planData[variantId] || [];
        var plan = null;
        if (selectedPlanId) {
          plan = plans.find(function(p) { return String(p.id) === String(selectedPlanId); });
        }
        if (!plan && plans.length) plan = plans[0];
        if (plan) subPrice = plan.priceFormatted;
      } catch(e) {}
    }
  }

  if (isSubscription && subPrice) {
    $compareEl.text(variantPrice).show();
    $priceEl.text(subPrice);
  } else {
    $compareEl.hide().text('');
    $priceEl.text(variantPrice);
  }

  $priceWrap.show();

  if ($formWrapper.find('.bundle-products-wrapper').length) {
    updateBundlePriceInButton($formWrapper);
  }
}

function formatPerItemPrice(formattedPrice, count) {
  var match = formattedPrice.replace(/\s/g, '').match(/^([^0-9]*)([0-9]+(?:[.,][0-9]+)*)([^0-9]*)$/);
  if (!match) return null;
  var prefix = match[1];
  var raw = parseFloat(match[2].replace(/,/g, ''));
  var suffix = match[3];
  return prefix + (raw / count).toFixed(2) + suffix;
}

function updateOptionPrices($formWrapper) {
  var $pricingEl = $formWrapper.find('.variant-pricing-data');
  if (!$pricingEl.length) return;

  var pricingData;
  try { pricingData = JSON.parse($pricingEl.text()); } catch(e) { return; }
  if (!pricingData.pricingOptionName || !pricingData.variants) return;

  var $pricingGroup = $formWrapper.find('.option-radio-group').filter(function() {
    return $(this).find('.option-radio-label--has-price').length > 0;
  }).first();
  if (!$pricingGroup.length) return;

  // Current selections from hidden selects (for matching other-option dimensions)
  var selectedOptions = {};
  $formWrapper.find('.featured-product__select-wrap select').each(function() {
    var pos = $(this).attr('name').replace('options', '');
    selectedOptions['option' + pos] = $(this).val();
  });

  var $subRadio = $formWrapper.find('.single-product__radio-input').filter(function() {
    var id = $(this).attr('id');
    return id === 'subscribe' || id === 'upsell-subscribe';
  });
  var isSubscription = $subRadio.is(':checked');
  var selectedPlanId = $formWrapper.find('.selling__plan-set-value').val();

  var optionPos = $pricingGroup.find('.option-radio-input').first().attr('data-option-position');
  var pricingKey = 'option' + optionPos;

  $pricingGroup.find('.option-radio-input').each(function() {
    var $radio = $(this);
    var radioVal = $radio.val();
    var $label = $('label[for="' + $radio.attr('id') + '"]');
    var $compareEl = $label.find('.option-radio-label__price-compare');
    var $currentEl = $label.find('.option-radio-label__price-current');
    if (!$currentEl.length) return;

    // Find the variant that matches this option value + all other current selections
    var matchingVariant = null;
    for (var i = 0; i < pricingData.variants.length; i++) {
      var v = pricingData.variants[i];
      if (v[pricingKey] !== radioVal) continue;
      var allMatch = true;
      $.each(selectedOptions, function(key, val) {
        if (key === pricingKey || !val) return;
        if (v[key] !== val) { allMatch = false; return false; }
      });
      if (allMatch) { matchingVariant = v; break; }
    }
    if (!matchingVariant) return;

    var displayPrice, displayCompare;
    if (isSubscription && matchingVariant.planPrices) {
      var subPrice = matchingVariant.planPrices[selectedPlanId];
      if (!subPrice) {
        var keys = Object.keys(matchingVariant.planPrices);
        if (keys.length) subPrice = matchingVariant.planPrices[keys[0]];
      }
      displayPrice = subPrice || matchingVariant.price;
      displayCompare = subPrice ? matchingVariant.price : null;
    } else {
      displayPrice = matchingVariant.price;
      displayCompare = null;
    }

    $currentEl.text(displayPrice);
    if (displayCompare) {
      $compareEl.text(displayCompare).show();
    } else {
      $compareEl.hide();
    }

    var $perItemEl = $label.find('.option-radio-label__per-item');
    if ($perItemEl.length && pricingData.perItem && pricingData.perItem.enabled) {
      var perItemCount = (matchingVariant.numberOfItems != null && matchingVariant.numberOfItems > 0)
        ? matchingVariant.numberOfItems
        : pricingData.perItem.count;
      if (perItemCount && perItemCount > 0) {
        var perItemFormatted = formatPerItemPrice(displayPrice, perItemCount);
        if (perItemFormatted !== null) {
          $perItemEl.text(perItemFormatted + ' per ' + pricingData.perItem.name);
        }
      }
    }
  });
}

function updateBundleOptionPrices($bundleSelector) {
  var $recurringNote = $bundleSelector.find('.bundle-recurring-note');
  if ($recurringNote.length) {
    var isSubscribed = $bundleSelector.find('.bundle-purchase-radio[value="subscribe"]').is(':checked');
    if (isSubscribed) {
      $recurringNote.show();
    } else {
      $recurringNote.hide();
    }
  }

  var $pricingEl = $bundleSelector.find('.bundle-variant-pricing-data');
  if (!$pricingEl.length) return;

  var pricingData;
  try { pricingData = JSON.parse($pricingEl.text()); } catch(e) { return; }
  if (!pricingData.pricingOptionName || !pricingData.variants) return;

  var $pricingGroup = $bundleSelector.find('.bundle-option-group').filter(function() {
    return $(this).find('.option-radio-label--has-price').length > 0;
  }).first();
  if (!$pricingGroup.length) return;

  var selectedOptions = {};
  $bundleSelector.find('.bundle-option-select').each(function() {
    var pos = $(this).data('option-position');
    selectedOptions['option' + pos] = $(this).val();
  });

  var $subRadio = $bundleSelector.find('.bundle-purchase-radio[value="subscribe"]');
  var isSubscription = $subRadio.is(':checked');
  var selectedPlanId = $bundleSelector.find('.bundle-selling-plan-value').val();

  var optionPos = $pricingGroup.find('.bundle-option-radio').first().attr('data-option-position');
  var pricingKey = 'option' + optionPos;

  $pricingGroup.find('.bundle-option-radio').each(function() {
    var $radio = $(this);
    var radioVal = $radio.val();
    var $label = $('label[for="' + $radio.attr('id') + '"]');
    var $compareEl = $label.find('.option-radio-label__price-compare');
    var $currentEl = $label.find('.option-radio-label__price-current');
    if (!$currentEl.length) return;

    var matchingVariant = null;
    for (var i = 0; i < pricingData.variants.length; i++) {
      var v = pricingData.variants[i];
      if (v[pricingKey] !== radioVal) continue;
      var allMatch = true;
      $.each(selectedOptions, function(key, val) {
        if (key === pricingKey || !val) return;
        if (v[key] !== val) { allMatch = false; return false; }
      });
      if (allMatch) { matchingVariant = v; break; }
    }
    if (!matchingVariant) return;

    var displayPrice, displayCompare;
    if (isSubscription && matchingVariant.planPrices) {
      var subPrice = matchingVariant.planPrices[selectedPlanId];
      if (!subPrice) {
        var keys = Object.keys(matchingVariant.planPrices);
        if (keys.length) subPrice = matchingVariant.planPrices[keys[0]];
      }
      displayPrice = subPrice || matchingVariant.price;
      displayCompare = subPrice ? matchingVariant.price : null;
    } else {
      displayPrice = matchingVariant.price;
      displayCompare = null;
    }

    $currentEl.text(displayPrice);
    if (displayCompare) {
      $compareEl.text(displayCompare).show();
    } else {
      $compareEl.hide();
    }

    var $perItemEl = $label.find('.option-radio-label__per-item');
    if ($perItemEl.length && pricingData.perItem && pricingData.perItem.enabled) {
      var perItemCount = (matchingVariant.numberOfItems != null && matchingVariant.numberOfItems > 0)
        ? matchingVariant.numberOfItems
        : pricingData.perItem.count;
      if (perItemCount && perItemCount > 0) {
        var perItemFormatted = formatPerItemPrice(displayPrice, perItemCount);
        if (perItemFormatted !== null) {
          $perItemEl.text(perItemFormatted + ' per ' + pricingData.perItem.name);
        }
      }
    }
  });
}

function updateSelectedColor(selectedInput) {
  var $colorGroup = $(selectedInput).closest(".featured-product__color-items");
  if (!$colorGroup.length) {
    $colorGroup = $(".featured-product__select-color").closest(".featured-product__color-items");
  }
  $colorGroup.find(".featured-product__select-color").css("background-color", "#F2F2F2");
  var selectedColor = $(selectedInput).data("color");
  $(selectedInput).closest(".featured-product__color-item").find(".featured-product__select-color").css("background-color", selectedColor);
}

function syncOtherFormOptions(selectedOptions, currentFormClass) {
  $('.product-form-wrapper').each(function () {
    var $otherForm = $(this);
    var otherFormClass = getProductFormClass($otherForm);

    if (otherFormClass === currentFormClass) {
      return; // skip current form
    }

    var formUpdated = false;

    $.each(selectedOptions, function (optionKey, optionValue) {
      if (!optionValue) return;
      var optionIndex = optionKey.replace('option', '');
      var optionName = 'options' + optionIndex;
      var $otherSelect = $otherForm.find('select[name="' + optionName + '"]');
      if (!$otherSelect.length) return;

      var hasMatch = false;
      $otherSelect.find('option').each(function () {
        if ($(this).val() === optionValue) {
          hasMatch = true;
          return false;
        }
      });

      if (!hasMatch) return;

      if ($otherSelect.val() !== optionValue) {
        $otherSelect.val(optionValue);
        formUpdated = true;
      }

      // Sync radio button UI in the other form
      var $radioGroup = $otherForm.find('.option-radio-group[data-select-name="' + optionName + '"]');
      if ($radioGroup.length) {
        $radioGroup.find('.option-radio-input').each(function () {
          $(this).prop('checked', $(this).val() === optionValue);
        });
      }
    });

    if (formUpdated) {
      updateVariantSelection(otherFormClass);
    }
  });
}

function updateValue(value,slicks) {
  var $value = $(value);
  var $formWrapper = $value.closest('.product-form-wrapper');

  if (!$formWrapper.length) {
    $formWrapper = $('.product-form-wrapper.main-product-form');
  }

  var formClass = getProductFormClass($formWrapper);
  var product_id = $value.attr("data-id");

  var $valueParent = $formWrapper.find(".hidden__input-value").first();
  if ($valueParent.length && product_id) {
    $valueParent.val(product_id);
  }
  var sale_price = $value.attr("data-variant-price");
  var variant_available = $value.attr("data-variant-available");

  var variant_image = $value.attr("data-variant-img");
  var variant_srcset = $value.attr("data-variant-srcset");
  if(slicks){
    updateVariantImage(variant_image, variant_srcset, formClass);
  }
  else{
    $(".featured__main-img").attr("src", variant_image);
  }
  


  // $(".featured-product__title-right span").text(sale_price);
  $(".featured-product__selling-plan del").text(sale_price);

  var $addCartBtn = $formWrapper.find(".add__cart-btn");
  if (variant_available == 'false') {
    $addCartBtn.addClass("disabled__btn");
  } else {
    $addCartBtn.removeClass("disabled__btn");
  }

}

$(document).ready(function () {
  var $optionSelects = $('.featured-product__select-wrap select');
  $optionSelects.on('change', updateVariantSelection);

  updateVariantSelection();

  var firstVariant = $(".featured-product__color-item input").first();
  if (firstVariant.length) {
    firstVariant.prop("checked", true);
    updateSelectedColor(firstVariant);
  }

  $(".featured-product__home-color input").on("change", function () {
    updateSelectedColor(this);
    updateValue(this, false);
  });

  $(".product__color-option input").on("change", function () {
    updateSelectedColor(this);
    updateValue(this, true);
  });
});



function sectionRendering() {

  fetch("?section_id=cart-drawer")
    .then((res) => res.text())
    .then((data) => {
      var cart__html = $(data);
      var render__html = $(".cart-drawer__cart-text", cart__html);
      $(".cart-drawer__cart-text").replaceWith(render__html);

      var render__html = $(".cart-drawer__wrap", cart__html);
      $(".cart-drawer__wrap").replaceWith(render__html);

      var render__html = $(".cart-drawer__bot-right h4", cart__html);
      $(".cart-drawer__bot-right h4").replaceWith(render__html);

      var render__html = $(".cart-drawer__announcement", cart__html);
      $(".cart-drawer__announcement").replaceWith(render__html);

      loadSlick();

    });
  // header 


  fetch("?section_id=header")
    .then((res) => res.text())
    .then((data) => {
      var cart__html = $(data);
      var render__html = $(".header__cart em", cart__html);
      $(".header__cart em").replaceWith(render__html);
    });


}


function addToCart_inCart(event, element) {
  event.preventDefault(); // Stop default action

  var variantId = $(element).attr('data-upsell-product'); // Use element instead of 'this'
  // console.log(variantId);

  var data = {
    id: variantId,
    quantity: 1
  };

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: data,
    dataType: "json",
    success: function (response) {
      // sectionRendering();
      // window.location = "/checkout"; // Redirect to cart page
    },
    error: function (err) {
      // console.log("Error adding product to cart:", err);
    }
  });
}


$(document).ready(function () {

  $(".single-product__radio-input").on("change", function () {

    var form = $(this).data("form");
    // Deselect all radio buttons that are not in this form
    $(".single-product__radio-input").not(this).prop("checked", false);
    if (!form) {
      updateVariantSelection();
      return;
    }
    var productType = $(this).data("product-type") || 'regular-select';
    $('.product-form-wrapper').hide();
    $('.product-slider-wrapper').hide();
    $('.'+form).show();

    var $formWrapper = $('.product-form-wrapper.' + form);
    var $sliderWrapper = $('.product-slider-wrapper.' + form);
    var normalizedFormClass = getProductFormClass($formWrapper);

    if ($sliderWrapper.length) {
      $sliderWrapper.show();
      var $imagesContainer = $sliderWrapper.find('.product__images');
      if ($imagesContainer.hasClass('slick-initialized')) {
        $imagesContainer.slick('setPosition');
      }
    }

    if (window.MightyProductSliders && typeof window.MightyProductSliders.refresh === 'function') {
      if ($sliderWrapper.length) {
        window.MightyProductSliders.refresh($sliderWrapper);
      } else {
        window.MightyProductSliders.refresh(normalizedFormClass);
      }
    }

    updateVariantSelection(normalizedFormClass);

    if (!$formWrapper.find('.featured-product__select-wrap select').length) {
      var $variantSelect = $formWrapper.find('select[name="id"].' + productType + ', select[name="id"]').first();
      var $selectedOption = $variantSelect.find('option:selected');
      if ($selectedOption.length) {
        updateVariantImage($selectedOption.attr('data-variant-img'), $selectedOption.attr('data-variant-srcset'), normalizedFormClass);
      }
    }

    if ($("#subscribe, #upsell-subscribe").is(":checked")) {
      $(".selling__plan-set-value").attr("name", "selling_plan");
      $('.checkout-note').attr("name", "properties[Please note]");
    } else {
      $(".selling__plan-set-value").attr("name", "")
      $('.checkout-note').attr("name", "");
    }
    $(".featured-product__subscription").not('.bundle-product-selector .featured-product__subscription').slideUp();
    var checkedId = $(".single-product__radio-input:checked").attr('id');
    $('label[for="'+checkedId+'"]').closest(".featured-product__purchase-item").find(".featured-product__subscription").slideDown();
    // $(".single-product__radio-input:checked").closest(".featured-product__purchase-item").find(".featured-product__subscription").slideDown();

    buildFrequencyDropdown($formWrapper);
    updateOptionPrices($formWrapper);
    updateCartBtnPrice($formWrapper);
  })

  // Custom frequency dropdown — toggle open/close
  $(document).on('click', '.freq-dropdown__trigger', function(e) {
    e.stopPropagation();
    var $dropdown = $(this).closest('.freq-dropdown');
    var isOpen = $dropdown.attr('aria-expanded') === 'true';
    $('.freq-dropdown').not($dropdown).attr('aria-expanded', 'false');
    $dropdown.attr('aria-expanded', isOpen ? 'false' : 'true');
    if (!isOpen) {
      $dropdown.find('.freq-dropdown__option[aria-selected="true"]').focus();
    }
  });

  // Custom frequency dropdown — option selection
  $(document).on('click', '.freq-dropdown__option', function() {
    var $option = $(this);
    var planId = $option.attr('data-value');
    var $dropdown = $option.closest('.freq-dropdown');
    var $fw = $option.closest('.product-form-wrapper');

    $dropdown.find('.freq-dropdown__option').attr('aria-selected', 'false');
    $option.attr('aria-selected', 'true');
    $dropdown.find('.freq-dropdown__selected-text').text($option.text());
    $dropdown.attr({ 'data-selected-id': planId, 'aria-expanded': 'false' });
    $fw.find('.selling__plan-set-value').val(planId);
    $dropdown.find('.freq-dropdown__trigger').focus();
    updateOptionPrices($fw);
    updateCartBtnPrice($fw);
  });

  // Close all dropdowns on outside click
  $(document).on('click', function(e) {
    if (!$(e.target).closest('.freq-dropdown').length) {
      $('.freq-dropdown').attr('aria-expanded', 'false');
    }
  });

  // Keyboard navigation within the dropdown
  $(document).on('keydown', '.freq-dropdown__trigger', function(e) {
    var $dropdown = $(this).closest('.freq-dropdown');
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') {
      $dropdown.attr('aria-expanded', 'true');
      $dropdown.find('.freq-dropdown__option[aria-selected="true"]').focus();
      e.preventDefault();
    }
  });

  $(document).on('keydown', '.freq-dropdown__option', function(e) {
    var $opt = $(this);
    var $dropdown = $opt.closest('.freq-dropdown');
    if (e.key === 'Enter' || e.key === ' ') {
      $opt.trigger('click');
      e.preventDefault();
    } else if (e.key === 'ArrowDown') {
      var $next = $opt.next('.freq-dropdown__option');
      if ($next.length) $next.focus();
      e.preventDefault();
    } else if (e.key === 'ArrowUp') {
      var $prev = $opt.prev('.freq-dropdown__option');
      if ($prev.length) $prev.focus();
      else $dropdown.find('.freq-dropdown__trigger').focus();
      e.preventDefault();
    } else if (e.key === 'Escape') {
      $dropdown.attr('aria-expanded', 'false');
      $dropdown.find('.freq-dropdown__trigger').focus();
      e.preventDefault();
    }
  });

  $(".add__cart-btn a").on("click", function (e) {
    e.preventDefault();
    var $form = $(this).closest(".single__product-add");
    var $formWrapper = $(this).closest(".product-form-wrapper");
    var isMv = $formWrapper.hasClass('product-form-wrapper--mv');
    var isBundle = $formWrapper.find('.bundle-products-wrapper').length > 0;

    if (isMv) {
      var mvItems = getMvCartItems($formWrapper);
      var bundleItems = isBundle ? getBundleCartItems($formWrapper) : [];
      var allItems = mvItems.concat(bundleItems);
      if (!allItems.length) return;
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        contentType: 'application/json',
        dataType: 'json',
        data: JSON.stringify({ items: allItems }),
        success: function(data) {},
        error: function(err) {}
      });
    } else if (isBundle) {
      addBundleToCart($form, $formWrapper);
    } else {
      addToCart($form.serialize());
    }
  })

  var $initialRadio = $(".single-product__radio-input:checked").first();
  if ($initialRadio.length) {
    $initialRadio.trigger('change');
  } else {
    updateVariantSelection();
  }
  // Allow slide navigation only after initial setup has completed
  setTimeout(function() { pageJustLoaded = false; }, 0);

  function addToCart(formData) {
    // console.log(formData);
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: formData,
      success: function (data) {
        // $('body').addClass("active-cart");
        // sectionRendering();
        // window.location = "/checkout"; // Redirect to cart page
      },
      error: function (err) {
        // console.log(err);
      },
    });
  }

});










/* <img onclick="removeItem(event,this)" data-line="{{ forloop.index }}" src="{{'delete.svg' |  asset_url }}" alt=""> */
function removeItem(event, el) {
  event.preventDefault();
  var data_line = $(el).attr("data-line");
  // console.log(data_line)
  var deleteData = {
    "line": data_line,
    "quantity": 0
  };
  // console.log(data_line)
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: deleteData,
    success: function (data) {
      // sectionRendering();
    }
  })
}


// remove item from cart drawer js end here



// increment quantity in cart drawer
function incrementCart(el) {
  var input = el.previousElementSibling;
  var value = parseInt(input.value);
  // console.log(value)
  value = isNaN(value) ? 0 : value
  value++;
  input.value = value;
  changeQuantity(input);

}
// decrement quantity in cart drawer
function decrementCart(el) {
  var input = el.nextElementSibling;
  var value = parseInt(input.value);
  if (value > 0) {
    value = isNaN(value) ? 0 : value;
    value--;
    input.value = value;
    changeQuantity(input);
  }
}

function changeQuantity(input) {

  var quantity = $(input).val();
  var data_line = $(input).attr("data-line");
  var data = {
    "line": data_line,
    "quantity": quantity
  };
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: data,
    success: function (data) {
      // console.log(data);
      // sectionRendering();
    },
    error: function (err) {
      // console.log("Error from quantity update")
    }
  })


}




function loadSlick() {
  $('.cart-drawer__upsell-items').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
    ]
  });
}


// ---- Bundle product support ----

function parseMoney(str) {
  if (!str) return 0;
  var cleaned = str.replace(/[^0-9.,]/g, '');
  var lastDot = cleaned.lastIndexOf('.');
  var lastComma = cleaned.lastIndexOf(',');
  if (lastComma > lastDot) {
    cleaned = cleaned.replace(/\./g, '').replace(',', '.');
  } else {
    cleaned = cleaned.replace(/,/g, '');
  }
  return parseFloat(cleaned) || 0;
}

function buildBundleFrequencyDropdown($bundleSelector) {
  var $dataEl = $bundleSelector.find('.bundle-selling-plan-data');
  if (!$dataEl.length) return;
  var plansByVariant;
  try { plansByVariant = JSON.parse($dataEl.text()); } catch(e) { return; }
  var variantId = $bundleSelector.find('.bundle-variant-id-select').val();
  var plans = (variantId && plansByVariant[variantId]) ? plansByVariant[variantId] : [];
  var $wrap = $bundleSelector.find('.bundle-frequency-wrap');
  var $dropdown = $bundleSelector.find('.bundle-freq-dropdown');
  if (!$wrap.length || !$dropdown.length) return;

  // Only show frequency picker when the subscribe radio is checked
  var $subRadio = $bundleSelector.find('.bundle-purchase-radio[value="subscribe"]');
  var subscribeChecked = !$subRadio.length || $subRadio.is(':checked');

  if (!subscribeChecked || plans.length === 0) { $wrap.hide(); return; }
  if (plans.length === 1) {
    $wrap.hide();
    $bundleSelector.find('.bundle-selling-plan-value').val(plans[0].id);
    return;
  }
  var prevId = parseInt($dropdown.attr('data-selected-id'), 10) || null;
  var stillAvailable = prevId && plans.some(function(p) { return p.id === prevId; });
  var selected = stillAvailable ? plans.find(function(p) { return p.id === prevId; }) : plans[0];
  var $list = $dropdown.find('.freq-dropdown__list');
  $list.empty();
  $.each(plans, function(i, plan) {
    $list.append(
      $('<li>').addClass('freq-dropdown__option bundle-freq-option')
        .attr({ role: 'option', 'aria-selected': plan.id === selected.id ? 'true' : 'false', 'data-value': plan.id, tabindex: '-1' })
        .text(plan.name)
    );
  });
  $dropdown.find('.freq-dropdown__selected-text').text(selected.name);
  $dropdown.attr('data-selected-id', selected.id);
  $bundleSelector.find('.bundle-selling-plan-value').val(selected.id);
  $wrap.show();
}

function resolveBundleVariant($bundleSelector) {
  var $optionSelects = $bundleSelector.find('.bundle-option-select');
  var $variantSelect = $bundleSelector.find('.bundle-variant-id-select');
  if (!$variantSelect.length) return;
  var selectedOptions = {};
  $optionSelects.each(function() {
    var pos = $(this).data('option-position');
    selectedOptions['option' + pos] = $(this).val();
  });
  if (!Object.keys(selectedOptions).length) return;
  var matchingOption = null;
  $variantSelect.find('option').each(function() {
    var $opt = $(this);
    var isMatch = true;
    $.each(selectedOptions, function(key, val) {
      if ($opt.attr(key) && $opt.attr(key) !== val) { isMatch = false; return false; }
    });
    if (isMatch) { matchingOption = $opt; return false; }
  });
  if (matchingOption) $variantSelect.val(matchingOption.val());
  buildBundleFrequencyDropdown($bundleSelector);
  updateBundleOptionPrices($bundleSelector);
  var $fw = $bundleSelector.closest('.product-form-wrapper');
  if ($fw.length) updateBundlePriceInButton($fw);
}

function updateBundlePriceInButton($formWrapper) {
  if ($formWrapper.hasClass('product-form-wrapper--mv')) {
    updateMvButtonPrice($formWrapper);
    return;
  }
  var $btn = $formWrapper.find('.add__cart-btn a');
  var $priceEl = $btn.find('.cart-btn__price');
  var $compareEl = $btn.find('.cart-btn__compare');
  var $priceWrap = $btn.find('.cart-btn__price-wrap');
  if (!$priceEl.length) return;

  // Compute MAIN product price from scratch (not from button text, which is already combined)
  var variantId, variantPriceFormatted;
  var $variantSelect = $formWrapper.find('select[name="id"]');
  if ($variantSelect.length) {
    var $selOpt = $variantSelect.find('option:selected');
    variantId = $selOpt.val();
    variantPriceFormatted = $selOpt.attr('data-variant-price');
  } else {
    var $hidden = $formWrapper.find('input[name="id"].hidden__input-value');
    variantId = $hidden.val();
    variantPriceFormatted = $hidden.attr('data-variant-price');
  }
  if (!variantId || !variantPriceFormatted) return;

  var symbol = variantPriceFormatted.replace(/[\d.,\s]/g, '') || '£';
  var mainCurrentPrice = parseMoney(variantPriceFormatted);
  var mainComparePrice = null;

  var $subRadio = $formWrapper.find('.single-product__radio-input').filter(function() {
    var id = $(this).attr('id');
    return id === 'subscribe' || id === 'upsell-subscribe';
  });
  var isSubscription = $subRadio.is(':checked');
  var selectedPlanId = $formWrapper.find('.selling__plan-set-value').val();

  if (isSubscription && selectedPlanId) {
    try {
      var planData = JSON.parse($formWrapper.find('.selling-plan-data').first().text());
      var plans = planData[variantId] || [];
      var plan = plans.find(function(p) { return String(p.id) === String(selectedPlanId); });
      if (!plan && plans.length) plan = plans[0];
      if (plan) {
        mainComparePrice = mainCurrentPrice;
        mainCurrentPrice = parseMoney(plan.priceFormatted);
      }
    } catch(e) {}
  }

  // Bundle products
  var bundleCurrentTotal = 0;
  var bundleCompareTotal = 0;
  $formWrapper.find('.bundle-product-selector').each(function() {
    var $bs = $(this);
    var $varSel = $bs.find('.bundle-variant-id-select');
    var $selOpt2 = $varSel.find('option:selected');
    var varPrice = parseMoney($selOpt2.attr('data-variant-price') || '0');
    var varCompare = varPrice;

    var $purchaseRadio = $bs.find('.bundle-purchase-radio:checked');
    var isSubscribe = $purchaseRadio.length > 0 ? $purchaseRadio.val() === 'subscribe' : false;
    var planId = isSubscribe ? $bs.find('.bundle-selling-plan-value').val() : null;

    if (planId) {
      try {
        var bpPlanData = JSON.parse($bs.find('.bundle-selling-plan-data').text());
        var vid = $varSel.val();
        var bpPlans = bpPlanData[vid] || [];
        var bpPlan = null;
        for (var i = 0; i < bpPlans.length; i++) {
          if (String(bpPlans[i].id) === String(planId)) { bpPlan = bpPlans[i]; break; }
        }
        if (!bpPlan && bpPlans.length) bpPlan = bpPlans[0];
        if (bpPlan) { varCompare = varPrice; varPrice = parseMoney(bpPlan.priceFormatted); }
      } catch(e) {}
    }
    bundleCurrentTotal += varPrice;
    bundleCompareTotal += varCompare;
  });

  var totalPrice = mainCurrentPrice + bundleCurrentTotal;
  var totalCompare = (mainComparePrice !== null ? mainComparePrice : mainCurrentPrice) + bundleCompareTotal;

  if (totalCompare > totalPrice) {
    $compareEl.text(symbol + totalCompare.toFixed(2)).show();
  } else {
    $compareEl.hide().text('');
  }
  $priceEl.text(symbol + totalPrice.toFixed(2));
  $priceWrap.show();
}

function getBundleCartItems($formWrapper) {
  var items = [];
  $formWrapper.find('.bundle-product-selector').each(function() {
    var $bs = $(this);
    var variantId = $bs.find('.bundle-variant-id-select').val();
    if (!variantId) return;
    var item = { id: parseInt(variantId, 10), quantity: 1 };
    var planId = $bs.find('.bundle-selling-plan-value').val();
    if (planId) item.selling_plan = parseInt(planId, 10);
    var isSubscribe = $bs.find('.bundle-purchase-radio[value="subscribe"]').is(':checked');
    if (isSubscribe) {
      var varSelect = $bs.find('.bundle-variant-id-select')[0];
      var selectedOpt = varSelect && varSelect.options[varSelect.selectedIndex];
      var noteAttr = selectedOpt && selectedOpt.getAttribute('data-subscription-cart-note');
      if (noteAttr) {
        try {
          var note = JSON.parse(noteAttr);
          if (note.title) {
            item.properties = {};
            item.properties[note.title] = note.description || '';
          }
        } catch(e) {}
      }
    }
    items.push(item);
  });
  return items;
}

function addBundleToCart($form, $formWrapper) {
  var formArray = $form.serializeArray();
  var mainItem = { quantity: 1 };
  var properties = {};
  $.each(formArray, function(_, pair) {
    if (pair.name === 'id') {
      mainItem.id = parseInt(pair.value, 10);
    } else if (pair.name === 'selling_plan' && pair.value) {
      mainItem.selling_plan = parseInt(pair.value, 10);
    } else if (pair.name.indexOf('properties[') === 0) {
      var key = pair.name.replace('properties[', '').replace(']', '');
      properties[key] = pair.value;
    }
  });
  if (Object.keys(properties).length) mainItem.properties = properties;
  var bundleItems = getBundleCartItems($formWrapper);
  var items = (mainItem.id && !isNaN(mainItem.id)) ? [mainItem].concat(bundleItems) : bundleItems;
  if (!items.length) return;
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    contentType: 'application/json',
    dataType: 'json',
    data: JSON.stringify({ items: items }),
    success: function(data) {},
    error: function(err) {}
  });
}

$(document).ready(function() {
  // Init bundle selectors on load
  $('.bundle-product-selector').each(function() {
    var $bs = $(this);
    $bs.find('.bundle-option-radio:checked').each(function() {
      var pos = $(this).data('option-position');
      $bs.find('.bundle-option-select[data-option-position="' + pos + '"]').val($(this).val());
    });
    resolveBundleVariant($bs);
    // Show subscription text for the initially-checked purchase radio
    // (runs after the main radio handler's global slideUp, so use show() not slideDown())
    var $checkedPurchase = $bs.find('.bundle-purchase-radio:checked');
    if ($checkedPurchase.length) {
      var bpId = $checkedPurchase.attr('id');
      $('label[for="' + bpId + '"]').find('.featured-product__subscription').show();
    }
  });

  // Bundle option radio change → resolve variant + update price
  $(document).on('change', '.bundle-option-radio', function() {
    var $bs = $(this).closest('.bundle-product-selector');
    var pos = $(this).data('option-position');
    $bs.find('.bundle-option-select[data-option-position="' + pos + '"]').val($(this).val());
    resolveBundleVariant($bs);
  });

  // Bundle purchase radio (subscribe/once) change
  $(document).on('change', '.bundle-purchase-radio', function() {
    var $radio = $(this);
    var $bs = $radio.closest('.bundle-product-selector');
    var $fw = $bs.closest('.product-form-wrapper');
    var bpIdx = $radio.data('bundle-index');

    // Slide subscription texts independently (don't let the main handler touch these)
    $bs.find('.featured-product__purchase-item').each(function() {
      var $item = $(this);
      var $purchaseRadio = $item.find('.bundle-purchase-radio');
      var $subText = $item.find('.featured-product__subscription');
      if ($subText.length) {
        if ($purchaseRadio.is(':checked')) {
          $subText.slideDown();
        } else {
          $subText.slideUp();
        }
      }
    });

    if ($radio.val() === 'once') {
      $bs.find('.bundle-selling-plan-value').val('');
      $bs.find('.bundle-frequency-wrap').hide();
    } else {
      var $dropdown = $bs.find('.bundle-freq-dropdown');
      var savedId = $dropdown.attr('data-selected-id');
      if (savedId) {
        $bs.find('.bundle-selling-plan-value').val(savedId);
      }
      buildBundleFrequencyDropdown($bs);
    }
    updateBundleOptionPrices($bs);
    if ($fw.length) updateBundlePriceInButton($fw);
  });

  // Bundle frequency dropdown option click
  $(document).on('click', '.bundle-freq-option', function() {
    var $opt = $(this);
    var planId = $opt.attr('data-value');
    var $dropdown = $opt.closest('.bundle-freq-dropdown');
    var $bs = $opt.closest('.bundle-product-selector');
    $dropdown.find('.freq-dropdown__option').attr('aria-selected', 'false');
    $opt.attr('aria-selected', 'true');
    $dropdown.find('.freq-dropdown__selected-text').text($opt.text());
    $dropdown.attr({ 'data-selected-id': planId, 'aria-expanded': 'false' });
    $bs.find('.bundle-selling-plan-value').val(planId);
    $dropdown.find('.freq-dropdown__trigger').focus();
    updateBundleOptionPrices($bs);
    var $fw = $bs.closest('.product-form-wrapper');
    if ($fw.length) updateBundlePriceInButton($fw);
  });

  // Bundle frequency keyboard navigation
  $(document).on('keydown', '.bundle-freq-option', function(e) {
    var $opt = $(this);
    var $dropdown = $opt.closest('.bundle-freq-dropdown');
    if (e.key === 'Enter' || e.key === ' ') {
      $opt.trigger('click'); e.preventDefault();
    } else if (e.key === 'ArrowDown') {
      var $next = $opt.next('.bundle-freq-option');
      if ($next.length) $next.focus(); e.preventDefault();
    } else if (e.key === 'ArrowUp') {
      var $prev = $opt.prev('.bundle-freq-option');
      if ($prev.length) $prev.focus();
      else $dropdown.find('.freq-dropdown__trigger').focus();
      e.preventDefault();
    } else if (e.key === 'Escape') {
      $dropdown.attr('aria-expanded', 'false');
      $dropdown.find('.freq-dropdown__trigger').focus();
      e.preventDefault();
    }
  });
});


// ---- Multi-Variant ATC ----

function activateMvCard($wrap) {
  if (!$wrap.length) return;
  $wrap.attr('data-mv-qty', 1).addClass('is-mv-selected');
  $wrap.find('.mv-qty__count').text(1);
  $wrap.find('.mv-qty__add').hide();
  $wrap.find('.mv-qty__stepper').show();
  $wrap.find('.option-radio-input').prop('checked', true);
  var $fw = $wrap.closest('.product-form-wrapper');
  if ($fw.length) updateMvButtonPrice($fw);
}

function initMvMode($formWrapper) {
  // Give each MV radio a unique name so multiple can be checked simultaneously,
  // reusing the existing :checked + label CSS for the selected-card appearance.
  $formWrapper.find('.option-radio-wrap--mv .option-radio-input').each(function() {
    var $r = $(this);
    $r.attr('name', $r.attr('name') + '--mv-' + $r.attr('id'));
  });
  // Start with all cards unselected
  $formWrapper.find('.option-radio-wrap--mv .option-radio-input').prop('checked', false);
}

function updateMvButtonPrice($formWrapper) {
  var $btn = $formWrapper.find('.add__cart-btn a');
  var $priceEl = $btn.find('.cart-btn__price');
  var $compareEl = $btn.find('.cart-btn__compare');
  var $priceWrap = $btn.find('.cart-btn__price-wrap');
  if (!$priceEl.length) return;

  var total = 0;
  var symbol = '£';
  var hasSelection = false;

  $formWrapper.find('.option-radio-wrap--mv').each(function() {
    var qty = parseInt($(this).attr('data-mv-qty') || '0', 10);
    if (qty > 0) {
      var priceStr = $(this).attr('data-variant-price') || '0';
      symbol = priceStr.replace(/[\d.,\s]/g, '') || symbol;
      total += parseMoney(priceStr) * qty;
      hasSelection = true;
    }
  });

  // Add bundle product prices (respecting selling plan selection)
  $formWrapper.find('.bundle-product-selector').each(function() {
    var $bs = $(this);
    var $varSel = $bs.find('.bundle-variant-id-select');
    var varPrice = parseMoney($varSel.find('option:selected').attr('data-variant-price') || '0');
    var $purchaseRadio = $bs.find('.bundle-purchase-radio:checked');
    var isSubscribe = $purchaseRadio.length > 0 && $purchaseRadio.val() === 'subscribe';
    var planId = isSubscribe ? $bs.find('.bundle-selling-plan-value').val() : null;
    if (planId) {
      try {
        var bpPlanData = JSON.parse($bs.find('.bundle-selling-plan-data').text());
        var bpPlans = bpPlanData[$varSel.val()] || [];
        var bpPlan = bpPlans.find(function(p) { return String(p.id) === String(planId); });
        if (!bpPlan && bpPlans.length) bpPlan = bpPlans[0];
        if (bpPlan) varPrice = parseMoney(bpPlan.priceFormatted);
      } catch(e) {}
    }
    total += varPrice;
  });

  if (hasSelection || $formWrapper.find('.bundle-product-selector').length) {
    $compareEl.hide().text('');
    $priceEl.text(symbol + total.toFixed(2));
    $priceWrap.show();
  } else {
    $priceWrap.hide();
  }
}

function getMvCartItems($formWrapper) {
  var items = [];
  var sellingPlan = null;
  var $subRadio = $formWrapper.find('.single-product__radio-input').filter(function() {
    var id = $(this).attr('id');
    return id === 'subscribe' || id === 'upsell-subscribe';
  });
  if ($subRadio.is(':checked')) {
    var planVal = $formWrapper.find('.selling__plan-set-value').val();
    if (planVal) sellingPlan = parseInt(planVal, 10);
  }

  $formWrapper.find('.option-radio-wrap--mv').each(function() {
    var qty = parseInt($(this).attr('data-mv-qty') || '0', 10);
    if (qty <= 0) return;
    var variantId = parseInt($(this).attr('data-variant-id'), 10);
    if (!variantId) return;
    var item = { id: variantId, quantity: qty };
    if (sellingPlan) item.selling_plan = sellingPlan;
    items.push(item);
  });
  return items;
}

$(document).ready(function() {
  // Clicking the card body (when not yet active) activates it
  $(document).on('click', '.option-radio-wrap--mv:not(.is-mv-selected)', function(e) {
    if ($(e.target).closest('.mv-qty-ctrl').length) return;
    activateMvCard($(this));
  });

  // + button: activate card at qty 1
  $(document).on('click', '.mv-qty__add', function(e) {
    e.stopPropagation();
    activateMvCard($(this).closest('.option-radio-wrap--mv'));
  });

  // Stepper + button: increase qty
  $(document).on('click', '.mv-qty__inc', function(e) {
    e.stopPropagation();
    var $wrap = $(this).closest('.option-radio-wrap--mv');
    var qty = parseInt($wrap.attr('data-mv-qty') || '1', 10) + 1;
    $wrap.attr('data-mv-qty', qty).find('.mv-qty__count').text(qty);
    var $fw = $wrap.closest('.product-form-wrapper');
    if ($fw.length) updateMvButtonPrice($fw);
  });

  // Stepper - button: decrease qty; at 0 revert to default state
  $(document).on('click', '.mv-qty__dec', function(e) {
    e.stopPropagation();
    var $wrap = $(this).closest('.option-radio-wrap--mv');
    var qty = parseInt($wrap.attr('data-mv-qty') || '1', 10) - 1;
    if (qty <= 0) {
      $wrap.removeAttr('data-mv-qty').removeClass('is-mv-selected');
      $wrap.find('.mv-qty__stepper').hide();
      $wrap.find('.mv-qty__add').show();
      $wrap.find('.option-radio-input').prop('checked', false);
    } else {
      $wrap.attr('data-mv-qty', qty).find('.mv-qty__count').text(qty);
    }
    var $fw = $wrap.closest('.product-form-wrapper');
    if ($fw.length) updateMvButtonPrice($fw);
  });

  // Init MV mode after all handlers are registered; no card is pre-activated
  $('.product-form-wrapper--mv').each(function() {
    initMvMode($(this));
  });
});